export default "__VITE_ASSET__OsnHRGHQ__"